import React, { useState } from 'react'
// import { Select } from 'antd'
//@ts-ignore
import s from './SelectGroupSide.module.scss'
import { ArrowTriangleBlack } from '../../../asset/icon/ArrowTriangleBlack';

import { SelectSearchIcon } from '../../../asset/icon/SelectSearchIcon';

import { useDispatch, useSelector } from 'react-redux';
import { setSideOptionsArray } from '../../../store/actions/setting';
import Select, { components } from "react-select";
import { getValueOption, getValueSideSectionOption, valueOption } from '../../../store/selectors/selectors';
import { SelectItemIcon } from '../../../asset/icon/SelectItemIcon';
export type valueSelect = {
    value: string,
    label: string
}

export type SelectGroupSideT = {
    values: valueSelect[]
    id: string
    optionCustom?: any
    selectValue: any
}

type getIconT = {
    showSearch: boolean,
    open: boolean,
    focused: boolean,
}


const customStyles = {
    option: (provided: any, state: any) => {
        let value = state.getValue()
        // debugger

        provided = {
            ...provided,
            padding: '0px '
            // background: '#F9F9F9 !important',
        }
        return { ...provided };
    },
    control: (provided: any, state: any) => {
        let menuIsOpen = state['menuIsOpen'];
        provided = {
            ...provided,
            borderRadius: '15px',
            borderBottomLeftRadius: menuIsOpen ? '0' : '15px',
            borderBottomRightRadius: menuIsOpen ? '0' : '15px',

            borderColor: '#DEDEDE !important',
            boxShadow: '0 0 1px #DEDEDE !important'
        }
        return { ...provided };
    },
    indicatorSeparator: (provided: any, state: any) => {
        provided = {
            ...provided,
            backgroundColor: 'transparent',

        }
        return { ...provided };
    },
    singleValue: (provided: any, state: any) => {

        return { ...provided };
    },
    menu: (provided: any, state: any) => {

        provided = {
            ...provided,
            marginBottom: '0px',
            marginTop: '0px',
            borderTopLeftRadius: '0',
            borderTopRightRadius: '0',
            borderTop: 'none',
            border: '1px solid #DEDEDE',
            boxShadow: 'none'
        }

        return { ...provided };
    },
    placeholder: (provided: any, state: any) => {

        provided = {
            ...provided,
            marginLeft: '0px',
            left: '16px',
            fontSize: '15px',
            lineHeight: 1.3,
            color: '#6a6a63',
            Left: '16px',
            position: 'absolute',
        }
        return { ...provided };
    },

}


export const SelectGroupSide = ({ ...props }: SelectGroupSideT): any => {

    const { values, id, optionCustom, selectValue } = props;

    const dispatch = useDispatch();


    function onChange({ id, value }: any) {
        dispatch(setSideOptionsArray({ idParams: id, valueParam: value.value }))
    }

    const SingleValue = () => {
        return (<div className={`${s.singleValue}`}>+ Add Item</div>)
    };
    const Option = (props: any) => {
        const { data, children } = props;
        let allItems = props.getValue()
        let isActive = allItems.filter((item: any) => item['idSection'] === data['value']);

        let isSelectedT = isActive.length > 0;

        let classOption = `${s.option}`
        if (isSelectedT) classOption += ` ${s.optionActive}`
        return (
            <components.Option {...props}   >
                <div className={classOption} >{children} {isSelectedT && (<SelectItemIcon />)}</div>
            </components.Option>
        )
    };





    // let classInput = `${s.selectStandard}`

    // function getIcon({ ...props }: getIconT): React.ReactNode {

    //     const { showSearch, open } = props

    //     let iconClass = `${s.iconSelect}`
    //     // if (!!selectValue) iconClass += ` ${s.rotated}`

    //     if (open && showSearch) {
    //         return <SelectSearchIcon />
    //     }
    //     return <ArrowTriangleBlack className={iconClass} />;
    // }


    return (
        <div className={s.boxSelect}>
            <Select
                styles={customStyles}
                value={selectValue}
                onChange={(value) => onChange({ id, value })}
                options={values}
                isSearchable={false}
                placeholder={'+ Add Item'}
                components={
                    {
                        'SingleValue': SingleValue,
                        'Option': !!optionCustom ? optionCustom : Option,
                    }
                }
            />
        </div >
    )
}





// const DisplayContainer: any = ({ ...props }: any) => {
//     debugger
//     return (
//         <div style={{ width: "120px", height: "53px" }}>
//             111

//         </div>
//     );
// };